/**
 * ALLOWLIST DE HTML para lo que escribe el editor rico (chat del claim, comentarios de alertas,
 * el contexto de un kudo).
 *
 * Estaba copiado igual en dos pantallas y estaba por copiarse en una tercera. Una función de
 * seguridad duplicada es una función que tarde o temprano se arregla en un solo lado: acá vive
 * una sola vez — y desde el 2026-09-15 es el MISMO tokenizer de `messageBody` (el de tres regex
 * se saltaba con `<img/onerror=…>` y `href="&#106;avascript:…"`).
 */
import { sanitizeHtml } from './messageBody';

export function sanitizeRichHtml(html: string): string {
  return sanitizeHtml(html || '');
}
